// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___71568b51c1b74550427","cls2":"Header-cls2___0ca8acc70eb396aa0df Header-cls1___71568b51c1b74550427"};